export default __webpack_public_path__ + "static/media/earphones5.afd0c1ae.jfif";